import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import jquery from "../../node_modules/jquery/src/jquery.js";
import barba from "@barba/core";
import LocomotiveScroll from 'locomotive-scroll';
import Swiper, { Navigation, Pagination, Grid } from 'swiper';

UIkit.use(Icons);
Swiper.use([Navigation, Pagination, Grid]);


/**
 * Rende disponibili le librerie nello scope globale.
 * Alternativamente, spostare gli import in app.js
 */
window.UIkit = UIkit;
window.$ = jquery;
window.barba = barba;
window.LocomotiveScroll = LocomotiveScroll;
window.Swiper = Swiper;

/**
 * Lazysizes
 */
 import lazySizes from 'lazysizes';
 lazySizes.cfg.init = false; // init manuale, v. sotto
 lazySizes.cfg.loadMode = 1; // 1 = only load visible elements
 window.lazySizes = lazySizes;